<template>
  <div style="max-height: 45vh; overflow-y: auto" class="pa-3">
    <!-- <v-card v-if="all_orders.length" class="elevation-0 pt-3">
      <v-row justify="space-around">
        <v-col cols='5'>
          <v-card class="elevation-1" style="border-radius: 8px;" rouded>
            <v-row class="pl-3 py-1" row wrap justify="space-around" align="center">
              <v-col cols='3'>
                <v-icon color="blue-grey darken-3">fa-dollar-sign </v-icon>
              </v-col>
              <v-col cols='9'>
                <h2 style="color: #455A64">R$ {{ total_in_currency }}</h2>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col cols='5'>
          <v-card class="elevation-1" style="border-radius: 8px;" rouded>
            <v-row class="pl-3 py-1" row wrap justify="space-around" align="center">
              <v-col cols='3'>
                <v-icon color="blue-grey darken-3">fa-layer-group </v-icon>
              </v-col>
              <v-col cols='9'>
                <h2 style="color: #455A64">{{ total_in_bags }} sacos</h2>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-card>
    <v-data-table :headers="headers" :items="all_orders" ref="table"  >
      <template v-slot:items="props">
        <tr @click="openOrder(props.item.id)" style="cursor: pointer">
          <td class="text-xs-center">
            <v-tooltip top color="black">
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" small :color="status_icons[props.item.order_status].color">{{
                  status_icons[props.item.order_status].icon
                }}</v-icon>
              </template>
              {{ status_icons[props.item.order_status].tip_text }}
            </v-tooltip>
          </td>
          <td class="text-xs-center" v-show="false">{{ props.item.created_at }}</td>
          <td class="text-xs-center">{{ props.item.criation }}</td>
          <td class="text-xs-center" v-show="false">{{ props.item.delivery_estimated_at }}</td>
          <td class="text-xs-center">{{ props.item.delivery_estimated }}</td>
          <td class="text-xs-center">{{ props.item.employee_name }}</td>
          <td class="text-xs-center">{{ props.item.delivery_city }}</td>
          <td class="text-xs-center">{{ props.item.total_order_bags }}</td>
          <td class="text-xs-center">{{ props.item.pl_brand }}</td>
          <td class="text-xs-center">R$ {{ props.item.bag_shipping_price.replace(/\d(?=(\d{3})+\.)/g, '$&,') }}</td>
          <td class="text-xs-center">R$ {{
            Number(props.item.total_order_sell).toFixed(2).replace(/\d(?=(\d{3})+\.)/g,
              '$&,')
          }}</td>
          <td class="text-xs-center">R$ {{ (parseFloat(props.item.total_order_sell - props.item.total_order_buy -
          props.item.order_shipping_price).toFixed(2)).replace(/\d(?=(\d{3})+\.)/g, '$&,') }} <span><v-icon
                v-if="props.item.total_order_buy == null" small color="warning">fa-exclamation-triangle</v-icon></span>
          </td>
          <td class="text-xs-center">{{ props.item.truck_plate }}</td>
        </tr>
      </template>
    </v-data-table>


    <v-dialog v-model="dialog_one_order" v-if="dialog_one_order" scrollable fullscreen persistent :overlay="false"
      transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="blue-grey">
          <v-btn icon dark @click.native="dialog_one_order = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Detalhes do Pedido {{ oneOrder? `- #${oneOrder.data.id}` : ''}}</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-container grid-list-sm v-if="!oneOrder">
          <v-alert color="white--text red" :value="true">
            Carregando pedido
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-alert>
        </v-container>

        <v-card-text v-if="oneOrder != null">
          <one-order :order_text="oneOrder.data.attributes.order_status"></one-order>
        </v-card-text>
      </v-card>
    </v-dialog> -->
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import Api from '@/api/index';

export default {
  components: {
    // OneOrder: () => import('@/_wholesale_order/components/order/_oneOrder.vue'),
    // ListOrders: () => import('@/listOrders'),
  },
  data() {
    return {
      key: null,
      all_orders: [],

      search: null,

      dialog_one_order: false,

      headers: [
        { text: 'Status', align: 'center', sortable: true, value: 'order_status' },
        { text: 'Data do pedido', align: 'center', sortable: true, value: 'created_at' },
        { text: 'Carregar', value: 'delivery_estimated_at', align: 'center' },
        { text: 'Vendedor', value: 'employee_name', align: 'center' },
        // { text: 'Cliente'   , value: 'client_name'   , align: 'center' },
        { text: 'Cidade', value: 'delivery_city', align: 'center' },
        { text: 'Qtd', value: 'total_order_bags', align: 'center' },
        { text: 'Marca', value: 'pl_brand', align: 'center' },
        { text: 'Frete', value: 'bag_shipping_price', align: 'center' },
        // { text: 'Compra'    , value: 'total_order_buy' , align: 'center' },
        { text: 'Venda', value: 'total_order_sell', align: 'center' },
        { text: 'Lucro', value: 'profitBag', align: 'center' },
        { text: 'Placa', value: 'truck_plate', align: 'center' },

        // { text: 'Lucro'     , value: 'totalProfit'   , align: 'center' },
        // { text: 'Pgto'      , value: 'pay_option_desc'   , align: 'center' },
        // { text: 'Prazo'     , value: 'pay_times_desc'  , align: 'center' },
        // { text: 'OK?'       , value: 'name'   , align: 'center',sortable: false },
      ],

      status_icons: {
        to_approve: {
          icon: 'fa-thumbs-up',
          color: 'primary',
          tip_text: 'A aprovar',
        },
        to_schedule: {
          icon: 'fa-calendar-day',
          color: 'success',
          tip_text: 'A marcar',
        },
        to_load: {
          icon: 'fa-truck-loading',
          color: 'success',
          tip_text: 'A carregar',
        },
        to_deliver: {
          icon: 'fa-truck',
          color: 'success',
          tip_text: 'A entregar',
        },
        to_be_paid: {
          icon: 'fa-check-double',
          color: 'success',
          tip_text: 'Entregue',
        },
        declined: {
          icon: 'fa-thumbs-down',
          color: 'error',
          tip_text: 'Recusado',
        },
        problem: {
          icon: 'fa-exclamation-circle',
          color: 'error',
          tip_text: 'Problema',
        },
      }

    }
  },
  methods: {
    // getClientOrders() {
    //   const id = this.oneClient ? this.oneClient.id : this.$route.params.id
    //   Api.Order.indexByClient(id).then(r => r.data).then(orders => {
    //     orders = orders.data ? orders.data.map(o => o.attributes) : orders
    //     this.all_orders = [...orders]
    //   })
    // },
    // openOrder(order_id) {
    //   this.dialog_one_order = true
    //   this.getOneOrder({ order_id: order_id })
    // },
    // ...mapActions({
    //   getOneOrder: 'Order/show',
    //   clearOrder: 'Order/clearOneOrder',
    // })
  },
  mounted() {
    // this.getClientOrders();
  },
  computed: {
    // total_in_currency() {
    //   if (this.all_orders) {
    //     // console.log(this.search);
    //     // console.log(this.search.length);

    //     var all_data = this.search ? this.$refs.table._data.internalCurrentItems : this.all_orders
    //     var b = all_data ? all_data.map(vt => parseFloat(vt.total_order_sell)).reduce((x, z) => x + z, 0) : null
    //     // if (b != null)
    //     return b ? b.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') : "0.00"
    //   }
    // },
    // total_in_bags() {
    //   var all_data = this.search ? this.$refs.table._data.internalCurrentItems : this.all_orders
    //   var b = all_data ? all_data.map(vt => parseFloat(vt.total_order_bags)).reduce((x, z) => x + z, 0) : null
    //   // if (b != null)
    //   return b ? b.toLocaleString('pt-BR') : "0"

    //   // return this.search? this.$refs.table._data.internalCurrentItems.length : this.all_orders.length
    // },
    // ...mapState({
    //   oneClient: state => state.Client.oneClient.data,
    //   oneOrder: state => state.Order.oneOrder,
    // })
  },
  watch: {
    dialog_one_order(nv, ov) {
      if (nv) {
      } else if (nv == false) {
        this.clearOrder()
      }
    },
  },
}
</script>
